module.exports = __webpack_public_path__ + "img/9791185435084.c8598236.jpg";